import { render } from "./ProductSeoComponent.vue?vue&type=template&id=e6fe5488"
import script from "./ProductSeoComponent.vue?vue&type=script&lang=js"
export * from "./ProductSeoComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__